import * as PlayerService from "@/services/player.service";

export const media = {
    namespaced: true,
    state: {
        mediaFile: null,
        playlist: [],
        playlistIndex: 0,
        repeatMode: 0,
        playerOpen: false
    },
    actions: {
        async play({ dispatch, commit }, payload) {
            const {
                files,
                shuffle = false
            } = Array.isArray(payload)
                    ? { files: payload, shuffle: false }
                    : payload;

            let playlist =
                await PlayerService.createPlaylist(files);

            if (!playlist.length)
                return false;

            if (shuffle) {
                playlist = PlayerService.shufflePlaylist(playlist);
            }

            commit("setPlaylist",playlist);
            commit("setPlaylistIndex",0);

            return await dispatch("playFile",playlist[0]);
        }, 
        async playFile({ commit, state, rootGetters }, item) {
            const file = {
                path: item.path ?? rootGetters["files/currentDirPath"],
                name: item.file?.name ?? item.name,
                isFile: item.isFile,
                meta: { ...item.meta }
            };

            const media = await PlayerService.playFile(file);

            if (!media)
                return false;

            let index =state.playlist.findIndex(item =>
                    item.path === media.path &&
                    item.name === media.name);

            if (index === -1) {
                commit("setPlaylist", [media]);
                index = 0;
            }

            commit("setPlaylistIndex",index);
            commit("setMediaFile", media);
            commit("setPlayerOpen",true);

            return true;
        },
        async playIndex({ dispatch, state }, index) {
            if (index < 0 ||index >= state.playlist.length) {
                return;
            }

            const file = state.playlist[index];

            if (!file)
                return false;

            await dispatch("playFile",state.playlist[index]);
        },
        async playPrev({ dispatch, state }) {
            if (state.playlistIndex <= 0)
                return;

            await dispatch("playIndex",state.playlistIndex - 1);
        },
        async playNext({ dispatch, state }) {
            if (state.playlistIndex >= state.playlist.length - 1) {
                return;
            }

            await dispatch("playIndex", state.playlistIndex + 1);
        },
        setPlaylist({ commit }, playlist) {
            commit("setPlaylist", playlist);
        },
        shufflePlaylist({ state, commit }) {
            const current = state.mediaFile?.name;
            const currentItem = state.playlist.find(f => f.name === current);
            const others = state.playlist.filter(f => f.name !== current);

            for (let i = others.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [others[i], others[j]] = [others[j], others[i]];
            }

            commit("setPlaylist", currentItem
                    ? [currentItem, ...others]
                    : others
            );
        },
        setRepeatMode({ commit }, mode) {
            commit("setRepeatMode", mode);
        },
        closePlayer({ commit }) {
            commit("setPlayerOpen", false);
            commit("setMediaFile", null);
            commit("setPlaylist", []);
            commit("setPlaylistIndex", 0);
        },
        async removePlaylist({ state, commit, dispatch }, index) {
            const removed = state.playlist[index];
            commit("removePlaylist", index);

            if (!removed)
                return;

            if (removed.name !== state.mediaFile?.name)
                return;

            if (index < state.playlist.length) {
                await dispatch("playIndex", index);
                return;
            }
            
            if (state.playlist.length) {
                await dispatch("playIndex", state.playlist.length - 1);
                return;
            }

            dispatch("closePlayer");
        }
    },
    mutations: {
        setMediaFile(state, media) {
            state.mediaFile = media;
        },
        setPlaylist(state, playlist) {
            state.playlist = playlist;
        },
        setPlaylistIndex(state, index) {
            state.playlistIndex = index;
        },
        setPlayerOpen(state, open) {
            state.playerOpen = open;
        },
        removePlaylist(state, index) {
            state.playlist.splice(index, 1);
        },
        setRepeatMode(state, mode) {
            state.repeatMode = mode;
        }
    }
}